"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(oldUpgradeData, newUpgradeData) {
  var upgradeDataIsSame = Boolean(oldUpgradeData.app === newUpgradeData.app && oldUpgradeData.screen === newUpgradeData.screen && oldUpgradeData.upgradeProduct === newUpgradeData.upgradeProduct && oldUpgradeData.uniqueId === newUpgradeData.uniqueId && oldUpgradeData.bundleUrl === newUpgradeData.bundleUrl);
  return !upgradeDataIsSame;
};

exports.default = _default;
module.exports = exports.default;